import { Injectable, Injector } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { catchError } from 'rxjs/operators';

import { ConfigurationService } from './configuration.service';
import { EndpointFactory } from './endpoint-factory.service';
import { ErrorHandleService } from './error-handle.service';
import { ClinicStatus } from '../models/clinic-status.model';

@Injectable({
  providedIn: 'root'
})

export class ClinicStatusEndpoint extends EndpointFactory {

  private readonly _baseUrl: string = "/api/ClinicStatus/";

  get baseUrl() { return this.configurations.baseUrl + this._baseUrl; }

  constructor(http: HttpClient, configurations: ConfigurationService,
    errorHandleService: ErrorHandleService, injector: Injector) {

    super(http, configurations, errorHandleService, injector);
  }

  getClinicStatusListEndpoint<T>(): Observable<T> {
    let endpointUrl = `${this.baseUrl}GetClinicStatusList`;

    return this.http.get<T>(endpointUrl, this.getRequestHeaders()).pipe<T>(
      catchError(error => {
        return this.errorHandleService.handleError(error, () => this.getClinicStatusListEndpoint());
      }));
  }

  getClinicStatusEndpoint<T>(id: number): Observable<T> {
    let endpointUrl = `${this.baseUrl}GetClinicStatus/${id}`;

    return this.http.get<T>(endpointUrl, this.getRequestHeaders()).pipe<T>(
      catchError(error => {
        return this.errorHandleService.handleError(error, () => this.getClinicStatusEndpoint(id));
      }));
  }

  updateStatusEndpoint(clinicStatus: ClinicStatus) {
    let endpointUrl = `${this.baseUrl}UpdateStatus/`;

    return this.http.post(endpointUrl, clinicStatus, this.getRequestHeaders()).pipe(
      catchError(error => {
        return this.errorHandleService.handleError(error, () => this.updateStatusEndpoint(clinicStatus));
      }));
  }
}
